// extracted by mini-css-extract-plugin
export var section = "Section-module--section--0c365";
export var imgWrapper = "Section-module--imgWrapper--8c6e1";
export var img = "Section-module--img--2ab61";
export var infoWrapper = "Section-module--infoWrapper--7b5eb";
export var title = "Section-module--title--e8ddd";
export var subtitle = "Section-module--subtitle--f0017";
export var notification = "Section-module--notification--6dc9f";